var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card", staticStyle: { "margin-bottom": "2em" } },
    [
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column location-card" }, [
            _c("p", [
              _c("b", { staticClass: "store-navigation-color" }, [
                _vm._v(_vm._s(_vm.name))
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n                        " +
                  _vm._s(_vm.address) +
                  "\n                        "
              ),
              _c("br"),
              _vm._v(" "),
              _vm.getPhone()
                ? _c(
                    "a",
                    {
                      staticClass: "store-loyalty-color",
                      attrs: {
                        "aria-label":
                          "store phone number is: " + _vm.getPhone(),
                        href: "tel:" + (_vm.location.contactPhone || _vm.phone)
                      }
                    },
                    [_vm._v(_vm._s(_vm.getPhone()))]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("p", [
              _c("span", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.emitStatus()
                      }
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.showDetails ? "Hide" : "View") +
                        " details"
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _vm.showDetails
              ? _c(
                  "div",
                  [
                    _vm._l(_vm.getWeek(), function(day, index) {
                      return _vm.$mq !== "mobile"
                        ? _c("p", { key: index }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(day.startTime.format("ddd hh:mma")) +
                                " - " +
                                _vm._s(day.endTime.format("hh:mma")) +
                                "\n                        "
                            )
                          ])
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm.$mq === "mobile" && _vm.location
                      ? _c(
                          "div",
                          { staticClass: "google-map" },
                          [
                            _c(
                              "GmapMap",
                              {
                                ref: "mapRef",
                                staticStyle: { width: "100%", height: "500px" },
                                attrs: {
                                  center: {
                                    lat: _vm.location.latitude,
                                    lng: _vm.location.longitude
                                  },
                                  zoom: 16
                                }
                              },
                              [
                                _c("google-marker-info-window", {
                                  attrs: { location: _vm.location },
                                  on: {
                                    click: function($event) {
                                      return _vm.focusOnLocation(_vm.location)
                                    },
                                    closeclick: function($event) {
                                      _vm.focusedLocation.id = null
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column is-narrow" }, [
            _c(
              "div",
              {
                staticClass:
                  "is-pulled-right-desktop  has-text-right has-text-centered-mobile"
              },
              [
                _vm.location.onlineStoreOpen
                  ? _c("BaseButton", {
                      attrs: {
                        classNames: ["is-rounded", "store-button-color"],
                        ariaLabel:
                          "order from store: " +
                          _vm.name +
                          " at " +
                          _vm.address,
                        title: _vm.location.onlineStoreOpen
                          ? "Order from here"
                          : "Please call store"
                      },
                      on: { click: _vm.handleClickSetLocation }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.location.onlineStoreOpen
                  ? _c("p", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.location.onlineStoreClosedMessage) +
                          "\n                        "
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cebfd04c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cebfd04c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/store-locator/LocationCard.vue
// module id = null
// module chunks = 